module.exports = __webpack_public_path__ + "img/warning.d9fb3582.png";